import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import getters from '@/store/getters'

import analyzes from "@/store/modules/analyzes";
import auth from '@/store/modules/auth';
import errors from '@/store/modules/errors';
import diagnosticFiles from "@/store/modules/diagnosticFiles";
import settings from "@/store/modules/settings";
import visits from "@/store/modules/visits";


Vue.use(Vuex)
const dataState = createPersistedState({
    paths: ['auth','settings'],
})
const store = new Vuex.Store({
    plugins: [dataState],
    modules: {
        auth,
        errors,
        settings,
        visits,
        analyzes,
        diagnosticFiles
    },
    getters
})
export default store
